const createNodeId = (type, nodeId) => {
  return `NODE=${type}__${nodeId}`;
};
const createNodeHandleId = (type, nodeId, handle = 0) => {
  return `NODE=${type}__${nodeId}-${handle}`;
};
const createEdgeId = (type1, type2, nodeId1, nodeId2, handle = 0) => {
  return `EDGE=${type1}->${type2}__${nodeId1}-${handle}->${nodeId2}`;
};

const edgeConfig = {
  // type: "smoothstep",
  // hidden: true,
  type: "custom",
  style: {},
  pathOptions: {
    // borderRadius: 20,
    // offset: -5,
    curvature: 1,
  },
  animated: true,
};

const nodeConfig = {
  // hidden: true,
  position: { x: 0, y: 0 },
  dragHandle: ".drag-handle",
};

export const connectInstitutionToAccounts = (data, graph) => {
  const nodes = [...graph.nodes];
  const edges = [...graph.edges];

  // separation of matter
  const { accounts, item } = data;

  // ===== DATA SANITIZATION ===== MOVE THIS PROCESS OUT EVENTUALLY
  accounts.forEach((account) => {
    // convert loans and credit card balances into negative
    if (account.type === "loan" || account.type === "credit") {
      account.balances.current *= -1;
    }
  });

  // ===== CREATE NODES AND EDGES ======
  // create institution node
  const institutionNode = {
    id: createNodeId("institution", item.institution_id),
    type: "institution",
    data: {
      ...item,
      balances: {},
      numberOfChildren: accounts.length,
      nodeId: createNodeId("institution", item.institution_id),
    },
    ...nodeConfig,
  };
  nodes.push(institutionNode);

  // sum account balances for institution node
  accounts.forEach((account) => {
    const institutionBalances = institutionNode.data.balances;
    const accountBalance = account.balances.current;
    const accountCurrency = account.balances.iso_currency_code;

    if (institutionBalances[accountCurrency] === undefined) {
      institutionBalances[accountCurrency] = 0;
    }
    institutionBalances[accountCurrency] += parseFloat(accountBalance);
  });

  // create account nodes
  accounts.forEach((account) => {
    const accountNode = {
      id: createNodeId("account", account.account_id),
      type: "account",
      data: account,
      ...item,
      ...nodeConfig,
    };
    // push to graph
    nodes.push(accountNode);
  });

  // create edges
  accounts.forEach((account, index) => {
    const institutionAccountEdge = {
      id: createEdgeId(
        "institution",
        "account",
        item.institution_id,
        account.account_id,
        index
      ),
      source: createNodeId("institution", item.institution_id),
      sourceHandle: createNodeHandleId(
        "institution",
        item.institution_id,
        index
      ),
      target: createNodeId("account", account.account_id),
      ...edgeConfig,
    };
    // push to graph
    edges.push(institutionAccountEdge);
  });

  return { nodes, edges };
};

export const connectProfileToInstitutions = (
  graph = { nodes: [], edges: [] }
) => {
  const nodes = [...graph.nodes];
  const edges = [...graph.edges];

  const data = {
    username: "thomasjuhoonkim",
    fullName: "Thomas Kim",
    userId: crypto.randomUUID(),
  };

  // filter institution nodes
  const institutions = nodes.filter((node) => node.type === "institution");

  // ===== CREATE NODES AND EDGES =====
  // create profile node
  const profileNode = {
    id: createNodeId("profile", data.userId),
    type: "profile",
    data: {
      ...data,
      balances: {},
      numberOfChildren: institutions.length,
      nodeId: createNodeId("profile", data.userId),
    },
    ...nodeConfig,
  };
  nodes.push(profileNode);

  // sum institution balances
  institutions.forEach((institution) => {
    Object.entries(institution.data.balances).forEach(([currency, amount]) => {
      const profileBalances = profileNode.data.balances;

      if (profileBalances[currency] === undefined) {
        profileBalances[currency] = 0;
      }
      profileBalances[currency] += parseFloat(amount);
    });
  });

  // create edges
  institutions.forEach((institution, index) => {
    const profileInstitutionEdge = {
      id: createEdgeId(
        "profile",
        "institution",
        data.userId,
        institution.data.institution_id,
        index
      ),
      source: createNodeId("profile", data.userId),
      sourceHandle: createNodeHandleId("profile", data.userId, index),
      target: createNodeId("institution", institution.data.institution_id),
      ...edgeConfig,
    };
    // push to graph
    edges.push(profileInstitutionEdge);
  });

  return { nodes, edges };
};
